<template>
	<div>
		<v-data-table :headers="fieldList" v-model="emailList" show-select :items="entityList" sort-by="id" :search="keyword" :footer-props="{ itemsPerPageOptions: [50,100,500,-1] }">
			<template v-slot:top>
				<v-row no-gutters style="padding:5px 0 0 0;">
					<v-col cols="12" sm="6">
						<div style="display:flex;justify-content:flex-start;align-items:center;">
							<v-btn fab x-small link color="primary" :to="'/administrator/tenant'">
								<v-icon>mdi-arrow-left</v-icon>
							</v-btn>
							<h3 style="margin-left:20px;">Staff List - {{tenant.name}}</h3>
						</div>
					</v-col>
					<v-col></v-col>
					<v-col cols="12" sm="6">
						<div class="d-flex px-2">
							<v-btn
								v-if="emailList.length > 0"
								:class="
									$vuetify.breakpoint.smAndDown &&
									$vuetify.breakpoint.width < 600
										? 'mb-2'
										: ''
								"
								color="primary"
								:block="
									$vuetify.breakpoint.smAndDown &&
									$vuetify.breakpoint.width < 600
								"
								style="margin-top:15px; margin-right:10px"
								@click="dialogEmailConfirmation = true"
							>Send to Selected User</v-btn>
							<v-text-field v-model="keyword" append-icon="mdi-magnify" label="Search" hide-details style="margin-right:10px;"></v-text-field>
							<v-btn fab x-small color="primary" @click="showAdd">
								<v-icon>mdi-plus</v-icon>
							</v-btn>
						</div>
					</v-col>
				</v-row>
			</template>			
			<template v-slot:item.active="{ item }">{{ item.active ? "Active" : "Inactive" }}</template>
			<template v-slot:item.emailed="{ item }">
				<v-tooltip bottom>
					<template v-slot:activator="{ on, attrs }">
						<v-icon
							v-bind="attrs"
							v-on="on"
							:color="item.emailed ? 'success' : ''"
							@click="
							emailList.push(item),
								(dialogEmailConfirmation = true)
						"
						>mdi-email-send</v-icon>
					</template>
					<span>{{item.dataMap.sendTime ? item.dataMap.sendTime : 'Not yet sent'}}</span>
				</v-tooltip>
			</template>
			<template v-slot:item.action="{ item }">
				<v-btn fab x-small @click="showEdit(item)">
					<v-icon>mdi-pencil</v-icon>
				</v-btn>
				<v-btn fab x-small style="margin-left:10px;" @click="showDelete(item.id)">
					<v-icon>mdi-delete</v-icon>
				</v-btn>
			</template>
			<template v-slot:no-data>Empty list</template>
		</v-data-table>

		<v-dialog v-model="dialogAdd.show" max-width="500">
			<v-card>
				<v-card-title>{{dialogAdd.title}}</v-card-title>

				<v-form class="px-5">
					<v-text-field v-model="entityAdd.email" label="Email"></v-text-field>
					<v-text-field v-model="entityAdd.title" label="Title"></v-text-field>
					<v-text-field v-model="entityAdd.firstName" label="First Name"></v-text-field>
					<v-text-field v-model="entityAdd.lastName" label="Last Name"></v-text-field>
					<v-text-field v-model="entityAdd.password" type="password" label="Password"></v-text-field>
					<v-switch v-model="entityAdd.active" :label="entityAdd.active ? 'Active' : 'Inactive'"></v-switch>
				</v-form>

				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn @click="dialogAdd.show = false">Cancel</v-btn>
					<v-btn color="primary" @click="add">Save</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<v-dialog v-model="dialogEdit.show" max-width="500">
			<v-card>
				<v-card-title>{{dialogEdit.title}}</v-card-title>

				<v-form class="px-5">
					<v-text-field v-model="entityEdit.email" label="Email" disabled></v-text-field>
					<v-text-field v-model="entityEdit.title" label="Title"></v-text-field>
					<v-text-field v-model="entityEdit.firstName" label="First Name"></v-text-field>
					<v-text-field v-model="entityEdit.lastName" label="Last Name"></v-text-field>
					<v-switch v-model="entityEdit.active" :label="entityEdit.active ? 'Active' : 'Inactive'"></v-switch>
				</v-form>

				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn @click="dialogEdit.show = false">Cancel</v-btn>
					<v-btn color="primary" @click="edit">Save</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<v-dialog v-model="dialogDelete.show" max-width="500">
			<v-card>
				<v-card-title>{{dialogDelete.title}}</v-card-title>

				<v-card-text class="px-5">{{dialogDelete.content}}</v-card-text>

				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn @click="dialogDelete.show = false">Cancel</v-btn>
					<v-btn color="accent" @click="remove">Delete</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<v-dialog v-model="dialogEmailConfirmation" max-width="400px">
			<v-card>
				<v-card-title class="headline info justify-center pa-12" primary-title>
					<v-icon color="white" size="120">mdi-email-alert-outline</v-icon>
				</v-card-title>

				<v-card-text class="pa-6" style="text-align: center">
					<p style="text-align: justify">Do you want to continue sending the email?</p>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="default" @click="
							(emailList = []), (dialogEmailConfirmation = false)
						">Cancel</v-btn>
					<v-btn color="primary" @click="sendNotification(emailList)">Confirm</v-btn>
					<v-spacer></v-spacer>
				</v-card-actions>
			</v-card>
		</v-dialog>

	</div>
</template>

<script>
/* eslint-disable no-unused-vars */
import axios from "axios";

export default {
	props: ["tenantId"],
	data() {
		return {
			dialogAdd: { show: false, title: "Add new tenant staff" },
			dialogEdit: { show: false, title: "Edit tenant staff" },
			dialogDelete: {
				show: false,
				title: "Delete tenant",
				content: "Are you sure you want to delete this tenant staff?"
			},
			entityAdd: { active: false },
			entityEdit: {},
			entityDelete: {},
			entityList: [],
			tenant: {},
			fieldList: [
				{ text: "Id", value: "id" },
				{ text: "Email", value: "email" },
				{ text: "Title", value: "title" },
				{ text: "First Name", value: "firstName" },
				{ text: "Last Name", value: "lastName" },
				{ text: "Status", value: "active" },
				{ text: "Emailed", value: "emailed" },
				{ text: "", value: "action", sortable: false }
			],
			keyword: "",
			emailList: [],
			dialogEmailConfirmation: false,
		};
	},
	mounted: function() {
		this.find();
		this.list();
	},
	methods: {
		find() {
			axios
				.get("/system/tenant?id=" + this.tenantId)
				.then(response => {
					this.tenant = response.data;
				})
				.catch(() => {});
		},
		list() {
			axios
				.get("/system/staff/list?tenantId=" + this.tenantId)
				.then(response => {
					this.entityList = response.data;
				})
				.catch(() => {});
		},
		showAdd() {
			this.entityAdd = { active: true };
			this.dialogAdd.show = true;
		},
		add() {
			this.entityAdd.tenantId = this.tenantId;
			axios
				.post("/system/staff/add", {
					entity: this.entityAdd
				})
				.then(response => {
					this.list();
					this.dialogAdd.show = false;
				})
				.catch(() => {});
		},
		showEdit(entity) {
			this.entityEdit = {
				id: entity.id,
				email: entity.email,
				title: entity.title,
				firstName: entity.firstName,
				lastName: entity.lastName,
				active: entity.active
			};
			this.dialogEdit.show = true;
		},
		edit() {
			this.entityEdit.tenantId = this.tenantId;
			axios
				.post("/system/staff/edit", {
					entity: this.entityEdit
				})
				.then(response => {
					this.dialogEdit.show = false;
					this.list();
				})
				.catch(() => {});
		},
		showDelete(entityId) {
			this.entityDelete.id = entityId;
			this.dialogDelete.show = true;
		},
		remove() {
			axios
				.post("/system/staff/delete", { id: this.entityDelete.id })
				.then(response => {
					this.list();
					this.dialogDelete.show = false;
				})
				.catch(() => {});
		},
		sendNotification(emailList) {
			this.dialogEmailConfirmation = false;
			let formData = new FormData();
			formData.append("entityList", JSON.stringify(emailList));
			axios
				.post("/system/staff/send/notification", formData)
				.then(() => {
					this.list();
					this.emailList = [];
				})
				.catch(() => {});
		},
	}
};
</script>
